<template>
  <header>
    <div class="container-fluid top-menu">
      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-sm-8 header-logo">
            <router-link to="/" class="logo-text d-none d-sm-block">
              <img class="site-logo" src="~@/assets/images/logo.webp" alt="Friday & Co. logo">
            </router-link>
            <router-link to="/" class="logo-text logo-text-mobile d-sm-none">
              <img class="site-logo" src="~@/assets/images/logo.webp" alt="Friday & Co. logo">
            </router-link>
          </div>
          <MobileMenu></MobileMenu>
          <div class="col-lg-8 navigation d-flex align-items-center">
            <ul class="header-nav-items menu">
              <li>
                <div>
                  <router-link class="header-nav-link" to="/our-story/">Our story</router-link>
                </div>
              </li>
              <li>
                <router-link class="header-nav-link" to="/mortgage-advice/">Mortgage Advice</router-link>
              </li>
              <li>
                <a href="https://www.rightmove.co.uk/estate-agents/agent/Friday-and-Co-Estate-Agents/Lowestoft-291410.html" target="_blank" rel="nofollow">Our Properties</a>
              </li>
              <li>
                <router-link class="header-nav-link" to="/contact-us/">Contact Us</router-link>
              </li>
              <li class="orangebackground">
                <a href="tel:01502802347" class="header-nav-link header-tel">
                  <strong>01502 802347</strong>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>

  import MobileMenu from "@/components/partials/MobileMenu";

  export default {
    name: "main-header",
    components: {
      MobileMenu,
    }
  };
</script>

<style scoped lang="scss">
.site-logo {
  max-height: 85px;
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/MainHeader.vue